import React from 'react'
import ReactSelect from './ReactSelect'
import { names, ucFirst, unslufigy } from '../../../helpers/StringHelper'
import { isArray } from '../../../helpers/DataHelper'
import store from "../../../Store";
import {setPlanMode} from "../../../pages/site/plan/list/PlanList-Action";

class SelectField extends React.Component
{


    placeholder()
    {
        let { placeholder, name, label } = this.props;
        if ( placeholder ) return placeholder;
        if ( label ) return label;
        else {
            if ( name ) {
                let _label = unslufigy( name );
                if ( name.includes(`_id`)) _label = ucFirst( name.split(`_id`)[0] );
                return _label;
            }
        }
    }

    labelText()
    {
        let { label, name } = this.props;
        if ( label ) return label;
        else {
            if ( name ) {
                let _label = unslufigy( name );
                if ( name.includes(`_id`)) _label = ucFirst( name.split(`_id`)[0] );
                return _label
            }
        }
    }

    closePlanUpdateForm(){
        store.dispatch(setPlanMode(" "));
    }

    optionLabel(o, customLabel, _label)
    {
        return customLabel
            ? `${ucFirst(o[customLabel[0]])} ( ${o[customLabel[1]]} )`
            : o[_label || `name`];
    }

    onChange = (selected) =>
    {
        let { onChange, name } = this.props;
        onChange({ target: { name, value: selected ? selected.value : `` } });
    };

    render()
    {
        let {
            options, name, _value, _label, disabled, value, noLabel,_customLabel,
            required, errors, processing, formGroupStyle
        } = this.props;

        let customLabel = _customLabel && _customLabel.split(',');
        let newValue =  ((typeof value === `string` || typeof value === `number`) && value !== '') ? String(value) : undefined;

        let selectOptions = options && isArray(options)
            ? options.map((o) => ({
                value: String(o[_value || `id`]),
                label: this.optionLabel(o, customLabel, _label),
            }))
            : [];

        let selectedOption = selectOptions.find((o) => o.value === newValue) || null;

        return (

            <div className={ names(
                `form-group`,
                `animated fadeIn faster`,
                errors && errors.length && `has-error`,
                required && `required`,
                processing && `processing`) }
                style={ formGroupStyle }
            >

                <div className="d-flex">

                <ReactSelect name={ name }
                        value={ selectedOption }
                        isDisabled={ disabled }
                        isClearable
                        placeholder={ !noLabel ? `Select ${this.placeholder()}` : `Select ${this.labelText()}` }
                        options={ selectOptions }
                        onChange={ this.onChange }
                        noFormGroup />
                      <i className="fa fa-times fa-lg mt-3 ml-2 onclick" aria-hidden="true" onClick={this.closePlanUpdateForm}></i>
                     </div>
            </div>

        )
    }
}
export default SelectField;
